/* Viora shop layer — cart drawer, predictive search, mobile gallery, header behaviour.
   Loads after viora-extras.js. All features fail silently if their markup is absent. */
(function () {
  var CFG = window.VIORA_SHOP || {};
  var FMT = CFG.moneyFormat || '${{amount}}';
  var THRESHOLD = typeof CFG.freeShipCents === 'number' ? CFG.freeShipCents : 3500;
  var body = document.body;

  /* ---------------- money ---------------- */
  function group(n) { return n.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'); }
  function formatMoney(cents) {
    cents = Number(cents) || 0;
    var value = '';
    var m = FMT.match(/\{\{\s*(\w+)\s*\}\}/);
    var kind = m ? m[1] : 'amount';
    if (kind === 'amount_no_decimals') value = group(Math.round(cents / 100).toString());
    else if (kind === 'amount_with_comma_separator') value = group((cents / 100).toFixed(2)).replace('.', ',');
    else value = group((cents / 100).toFixed(2));
    return FMT.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ---------------- header condense ---------------- */
  var header = document.querySelector('.site-header');
  var heroDark = document.querySelector('[data-hero-dark]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('scrolled', window.scrollY > 12);
      /* dark while the header sits over the dark hero, light after it */
      if (heroDark) header.classList.toggle('on-dark', heroDark.getBoundingClientRect().bottom > header.getBoundingClientRect().bottom + 4);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  }

  /* ---------------- smoother images: fade in once loaded ---------------- */
  (function () {
    var SEL = '.p-thumb img, .tile-img, .sold-thumb img, .band-media img';
    var html = document.documentElement;
    function settle(img) {
      if (img.complete && img.naturalWidth) { img.classList.add('is-in'); return; }
      var done = function () { img.classList.add('is-in'); };
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
    }
    function scan(root) {
      if (root.matches && root.matches(SEL)) settle(root);
      if (root.querySelectorAll) root.querySelectorAll(SEL).forEach(settle);
    }
    /* mark what's already loaded first, then turn the effect on, so nothing flickers */
    document.querySelectorAll(SEL).forEach(function (img) { if (img.complete && img.naturalWidth) img.classList.add('is-in'); });
    html.classList.add('vr-fade');
    scan(document);
    if ('MutationObserver' in window) {
      new MutationObserver(function (list) {
        list.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) scan(n); }); });
      }).observe(document.body, { childList: true, subtree: true });
    }
  })();

  /* ---------------- homepage hero: pause the animation while it's off screen ---------------- */
  if (heroDark && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      heroDark.classList.toggle('vu-paused', !entries[0].isIntersecting);
    }).observe(heroDark);
  }

  /* ---------------- scroll lock for the cart drawer + search ----------------
     iPhone Safari ignores overflow:hidden for touch scrolling, so a swipe in the
     cart could scroll the store page behind it instead. While a panel is open,
     any touch-scroll that isn't inside one of its scrollable areas is cancelled,
     and scrolls stop at the top/bottom of the list instead of leaking through. */
  var htmlEl = document.documentElement;
  var lockCount = 0, touchY = 0, touchX = 0;
  var SCROLLERS = '.vd-body, .vd-foot, .vs-panel, .bo-modal';
  function lockScroll() { if (lockCount++ === 0) htmlEl.classList.add('vr-lock'); }
  function unlockScroll() { if (lockCount > 0 && --lockCount === 0) htmlEl.classList.remove('vr-lock'); }
  document.addEventListener('touchstart', function (e) {
    if (!lockCount || e.touches.length !== 1) return;
    touchY = e.touches[0].clientY;
    touchX = e.touches[0].clientX;
  }, { passive: true });
  /* Safety: a lock only counts while a panel is actually open. If one got left
     behind (back button, a closed tab, an error), drop it so the page can scroll. */
  function panelOpen() {
    var b = document.body;
    return !!(b && (b.classList.contains('cart-open') || b.classList.contains('search-open') || document.querySelector('.bo-veil.is-on')));
  }
  function clearStaleLock() {
    if (lockCount && !panelOpen()) { lockCount = 0; htmlEl.classList.remove('vr-lock'); }
  }
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    lockCount = 0; htmlEl.classList.remove('vr-lock'); htmlEl.style.overflow = '';
    if (document.body) document.body.classList.remove('cart-open', 'search-open', 'menu-open');
  });
  document.addEventListener('touchmove', function (e) {
    if (lockCount) clearStaleLock();
    if (!lockCount || e.touches.length !== 1) return; /* two fingers = pinch zoom, leave it */
    var y = e.touches[0].clientY, x = e.touches[0].clientX;
    var dy = y - touchY, dx = x - touchX;
    touchY = y; touchX = x;
    var t = e.target && e.target.nodeType === 1 ? e.target : (e.target && e.target.parentElement);
    if (!t) return;
    if (Math.abs(dx) > Math.abs(dy) && t.closest('.vd-setup-row')) return; /* swiping through suggestions */
    var sc = t.closest(SCROLLERS);
    var block = !sc || sc.scrollHeight <= sc.clientHeight + 1 ||
      (sc.scrollTop <= 0 && dy > 0) ||
      (sc.scrollTop + sc.clientHeight >= sc.scrollHeight - 1 && dy < 0);
    if (block && e.cancelable) e.preventDefault();
  }, { passive: false });

  /* ---------------- bonus card preference (cart attribute, synced everywhere) ---------------- */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-bonus-pref]');
    if (!input) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { 'Bonus Card Preference': input.value } })
    }).catch(function () {});
  });
  fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
    var val = cart.attributes && cart.attributes['Bonus Card Preference'];
    if (!val) return;
    document.querySelectorAll('[data-bonus-pref]').forEach(function (input) {
      if (input.value === val) input.checked = true;
    });
  }).catch(function () {});

  /* ---------------- cart count everywhere ---------------- */
  function paintCount(n) {
    document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = n; });
    document.querySelectorAll('.mt-badge').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('on', n > 0);
    });
  }

  /* ---------------- auto gift-with-purchase ---------------- */
  var GIFT_RULES = (window.VIORA_GIFT_RULES && window.VIORA_GIFT_RULES.length) ? window.VIORA_GIFT_RULES : [];

  function syncGifts(cart) {
    if (!GIFT_RULES.length) return Promise.resolve({ cart: cart, changed: false });

    var actions = [];
    GIFT_RULES.forEach(function (rule) {
      var have = 0;
      cart.items.forEach(function (item) { if (item.handle === rule.trigger_handle) have += item.quantity; });
      var giftLine = -1;
      var giftKey = null;
      cart.items.forEach(function (item, idx) {
        if (item.variant_id === rule.gift_variant_id && item.properties && item.properties._auto_gift === 'true') {
          giftLine = idx + 1;
          giftKey = item.key;
        }
      });
      if (have >= rule.trigger_qty && giftLine === -1) {
        actions.push({ type: 'add', variant_id: rule.gift_variant_id });
      } else if (have < rule.trigger_qty && giftLine > -1) {
        actions.push({ type: 'remove', key: giftKey });
      }
    });

    if (!actions.length) return Promise.resolve({ cart: cart, changed: false });

    var chain = Promise.resolve();
    actions.forEach(function (action) {
      chain = chain.then(function () {
        if (action.type === 'add') {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: action.variant_id, quantity: 1, properties: { _auto_gift: 'true' } })
          }).catch(function () {});
        }
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: action.key, quantity: 0 })
        }).catch(function () {});
      });
    });

    return chain.then(function () {
      return fetch((CFG.cartUrl || '/cart') + '.js', { headers: { Accept: 'application/json' } });
    }).then(function (r) { return r.json(); })
      .then(function (finalCart) { return { cart: finalCart, changed: true }; })
      .catch(function () { return { cart: cart, changed: false }; });
  }

  /* ---------------- cart mutation queue ----------------
     Every cart-changing request (page-load gift sync, drawer steppers,
     cart page qty/remove controls) runs through this so two of them can
     never fire at once and act on out-of-date cart state. */
  var cartChain = Promise.resolve();
  function enqueueCart(task) {
    cartChain = cartChain.then(task, task);
    return cartChain;
  }

  /* ---------------- cart drawer ---------------- */
  var drawer = document.getElementById('CartDrawer');
  var dBody = document.getElementById('CartDrawerBody');
  var dFoot = document.getElementById('CartDrawerFoot');
  var dShip = document.getElementById('CartDrawerShip');
  var lastFocus = null;

  function openCart() {
    if (!drawer) { window.location.href = CFG.cartUrl || '/cart'; return; }
    if (body.classList.contains('cart-open')) return;
    lastFocus = document.activeElement;
    body.classList.add('cart-open');
    lockScroll();
    var close = drawer.querySelector('.vd-close');
    if (close) close.focus({ preventScroll: true });
  }
  function closeCart() {
    if (!body.classList.contains('cart-open')) return;
    body.classList.remove('cart-open');
    unlockScroll();
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  /* Free shipping reminder: one slim line under "Your cart" plus a 3px bar
     that doubles as the header divider. */
  var TRUCK = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h11v9H3z"/><path d="M14 9h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg>';
  var CHECK = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  function shipLeft(cart) {
    if (!THRESHOLD || CFG.shipReminder === false || !cart || !cart.items || !cart.items.length) return null;
    return THRESHOLD - cart.total_price;
  }

  function renderShip(cart) {
    if (!dShip) return;
    var left = shipLeft(cart);
    if (left === null) { dShip.innerHTML = ''; return; }
    var pct = Math.min(100, Math.max(0, Math.round((cart.total_price / THRESHOLD) * 100)));
    var lineHtml = left > 0
      ? TRUCK + '<span>You\'re <b>' + formatMoney(left) + '</b> away from free shipping</span>'
      : CHECK + '<span>Free shipping unlocked</span>';
    var line = dShip.querySelector('.vd-shipline');
    var fill = dShip.querySelector('.vd-shipbar i');
    if (line && fill) {
      line.innerHTML = lineHtml;
      line.classList.toggle('is-done', left <= 0);
      fill.style.width = pct + '%';
      return;
    }
    dShip.innerHTML =
      '<div class="vd-shipline' + (left > 0 ? '' : ' is-done') + '" role="status">' + lineHtml + '</div>' +
      '<div class="vd-shipbar" aria-hidden="true"><i style="width:' + pct + '%"></i></div>';
  }

  var lastSig = '';
  function cartSig(c) {
    return JSON.stringify([c.total_price, c.original_total_price, c.total_discount, c.item_count,
      (c.items || []).map(function (i) { return [i.key, i.quantity, i.final_line_price]; }),
      (c.discount_codes || []).map(function (d) { return [d.code, d.applicable]; })]);
  }

  function renderCart(cart) {
    lastCart = cart;
    paintCount(cart.item_count);
    if (!dBody) return;
    var sig = cartSig(cart);
    if (sig === lastSig && dBody.childElementCount) { paintDisc('drawer'); return; }
    lastSig = sig;

    if (!cart.items.length) {
      dBody.innerHTML = '<div class="vd-empty">Your cart is empty.<br>Pick out something to protect.</div>';
      if (dFoot) dFoot.innerHTML = '<a class="vd-checkout" style="display:block;text-align:center" href="' + (CFG.shopUrl || '/collections/all') + '">Start shopping</a>';
      renderShip(cart);
      return;
    }

    var html = ''; /* gift reminders are left out of the drawer to keep it clean */
    cart.items.forEach(function (item, i) {
      var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
      var isFree = item.final_line_price === 0 && item.original_line_price > 0;
      var cut = !isFree && item.final_line_price < item.original_line_price;
      html +=
        '<div class="vd-item" data-line="' + (i + 1) + '">' +
          (img ? '<img src="' + img + '" alt="" decoding="async" width="68" height="68">' : '<div class="vs-thumb"></div>') +
          '<div class="vd-meta">' +
            '<b>' + escapeHtml(item.product_title) + '</b>' +
            (item.variant_title ? '<span class="vd-variant">' + escapeHtml(item.variant_title) + '</span>' : '') +
            (isFree ? '<span class="vd-free-tag"><svg class="gift-ico" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5C10 3 12 8 12 8s2-5 4.5-5a2.5 2.5 0 0 1 0 5"/></svg>Free gift</span>' : '') +
            '<div class="vd-row">' +
              '<span class="vd-step">' +
                '<button type="button" data-step="-1" aria-label="Decrease quantity">−</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" data-step="1" aria-label="Increase quantity">+</button>' +
              '</span>' +
              '<span class="vd-line">' + (isFree
                ? '<b class="vd-free-price">FREE</b>'
                : (cut ? '<s class="vd-was">' + formatMoney(item.original_line_price) + '</s>' : '') + formatMoney(item.final_line_price)) + '</span>' +
            '</div>' +
          '</div>' +
        '</div>';
    });
    /* Everything below the items scrolls with them, so the pinned footer
       stays small: total, savings, checkout. */
    var parts = totalsParts(cart);
    html +=
      setupHtml(cart) +
      '<div class="vd-extras">' +
        discountBoxHtml('drawer') +
        (parts.rows ? '<div class="vtot vd-breakdown" data-cart-totals>' + parts.rows + '</div>' : '') +
        '<div class="vd-note">Shipping and taxes calculated at checkout. Checked and packed by hand before it ships.</div>' +
      '</div>';
    var keepScroll = dBody.scrollTop;
    var setupRow = dBody.querySelector('.vd-setup-row');
    var keepSwipe = setupRow ? setupRow.scrollLeft : 0;
    dBody.innerHTML = html;
    dBody.scrollTop = keepScroll;
    Object.keys(stepPending || {}).forEach(function (ln) {
      var n = dBody.querySelector('.vd-item[data-line="' + ln + '"] .vd-step span');
      if (n) n.textContent = stepPending[ln];
    });
    var newRow = dBody.querySelector('.vd-setup-row');
    if (newRow) newRow.scrollLeft = keepSwipe;

    if (dFoot) {
      dFoot.innerHTML =
        '<div class="vtot" data-cart-totals>' + parts.total + '</div>' +
        '<button type="button" class="vd-checkout" id="VDCheckout">Check out</button>' +
        '<a class="vd-view" href="' + (CFG.cartUrl || '/cart') + '">View full cart</a>';
    }
    paintDisc('drawer');
    renderShip(cart);
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------------- discount codes + savings ----------------
     Codes live on the Shopify cart (Ajax API: POST /cart/update.js with
     { discount: "CODE1,CODE2" }), so they carry straight through to checkout.
     The cart page renders the same markup server-side from
     snippets/cart-totals.liquid and snippets/cart-discount.liquid. */
  var lastCart = null;
  var DISC = {
    drawer: { open: false, value: '', msg: '', kind: '' },
    page: { open: false, value: '', msg: '', kind: '' }
  };
  var TAG_ICON = '<svg class="vtot-ico" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z"/><circle cx="7.5" cy="7.5" r="1.5"/></svg>';
  var MINUS = '−';

  function upper(s) { return String(s == null ? '' : s).trim().toUpperCase(); }

  /* Every discount on the cart, merged by name, with the amount it takes off. */
  function discountLines(cart) {
    var map = {}, order = [];
    function add(title, type, amount, pending) {
      var isCode = type === 'discount_code';
      var key = (isCode ? 'c:' : 'a:') + upper(title);
      if (!map[key]) { map[key] = { title: String(title || 'Discount'), code: isCode, amount: 0 }; order.push(key); }
      map[key].amount += Number(amount) || 0;
    }
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (a) {
        var app = a.discount_application || {};
        add(app.title, app.type, a.amount);
      });
    });
    (cart.cart_level_discount_applications || []).forEach(function (app) {
      add(app.title, app.type, app.total_allocated_amount);
    });
    /* Applied codes with nothing taken off yet (free shipping codes) */
    (cart.discount_codes || []).forEach(function (c) {
      if (c && c.applicable !== false) add(c.code, 'discount_code', 0);
    });
    return order.map(function (k) { return map[k]; }).filter(function (l) { return l.code || l.amount > 0; });
  }

  /* rows  = Subtotal + one line per discount (empty when no discounts)
     total = Estimated total + savings bar, or a plain Subtotal */
  function totalsParts(cart) {
    var lines = discountLines(cart);
    if (!lines.length) {
      return { rows: '', total: '<div class="vtot-row vtot-total"><span>Subtotal</span><span class="mono">' + formatMoney(cart.total_price) + '</span></div>' };
    }
    var saved = typeof cart.total_discount === 'number'
      ? cart.total_discount
      : Math.max(0, (cart.original_total_price || 0) - (cart.total_price || 0));
    var html = '<div class="vtot-row"><span>Subtotal</span><span class="mono">' + formatMoney(cart.original_total_price) + '</span></div>';
    lines.forEach(function (l) {
      var name = escapeHtml(l.title);
      html +=
        '<div class="vtot-row vtot-disc"><span class="vtot-label">' +
          (l.code
            ? '<span class="vtot-code">' + name + '<button type="button" class="vtot-x" data-discount-remove="' + name + '" aria-label="Remove discount ' + name + '">&times;</button></span>'
            : TAG_ICON + '<span class="vtot-name">' + name + '</span>') +
        '</span>' +
        (l.amount > 0
          ? '<span class="mono vtot-amt">' + MINUS + formatMoney(l.amount) + '</span>'
          : '<span class="vtot-later">At checkout</span>') +
        '</div>';
    });
    var total = '<div class="vtot-row vtot-total"><span>Estimated total</span><span class="mono">' + formatMoney(cart.total_price) + '</span></div>';
    if (saved > 0) total += '<div class="vtot-save">You\'re saving ' + formatMoney(saved) + '</div>';
    return { rows: html, total: total };
  }

  function totalsInner(cart) {
    var p = totalsParts(cart);
    return p.rows + p.total;
  }

  /* ---------------- complete your setup ----------------
     Hand-picked pairings come from the product metafield custom.complete_setup
     (product list). Anything still empty is filled from the fallback collection
     (theme setting, defaults to Accessories). Built in layout/theme.liquid. */
  var SETUP = window.VIORA_SETUP || null;
  var SETUP_MAX = 4;

  function pickSetup(cart) {
    if (!SETUP || !cart.items.length) return [];
    var inCart = {}, seen = {}, out = [];
    cart.items.forEach(function (i) { inCart[i.product_id] = true; });
    function consider(p) {
      if (!p || out.length >= SETUP_MAX || seen[p.id] || inCart[p.id] || !p.available || !(p.price > 0)) return;
      seen[p.id] = true;
      out.push(p);
    }
    cart.items.forEach(function (i) { ((SETUP.pairs || {})[i.product_id] || []).forEach(consider); });
    (SETUP.fallback || []).forEach(consider);
    return out;
  }

  function setupHtml(cart) {
    var picks = pickSetup(cart);
    if (!picks.length) return '';
    var left = shipLeft(cart);
    /* scale by the cart's current discount so a % code is accounted for */
    var ratio = cart.original_total_price ? cart.total_price / cart.original_total_price : 1;
    var cards = picks.map(function (p) {
      var unlocks = left !== null && left > 0 && p.price * ratio >= left;
      var title = escapeHtml(p.title);
      var url = escapeHtml(p.url);
      return '<div class="vd-up">' +
        '<a class="vd-up-img" href="' + url + '" tabindex="-1" aria-hidden="true">' +
          (p.image ? '<img src="' + escapeHtml(p.image) + '" alt="" decoding="async" width="56" height="56">' : '') +
        '</a>' +
        '<div class="vd-up-meta">' +
          '<a class="vd-up-title" href="' + url + '">' + title + '</a>' +
          '<span class="vd-up-price">' + formatMoney(p.price) + '</span>' +
          (unlocks ? '<span class="vd-up-ship">Unlocks free shipping</span>' : '') +
        '</div>' +
        (p.multi
          ? '<a class="vd-up-add vd-up-opt" href="' + url + '" aria-label="Choose options for ' + title + '">Options</a>'
          : '<button type="button" class="vd-up-add" data-up-add="' + p.variant_id + '" aria-label="Add ' + title + ' to cart">+</button>') +
      '</div>';
    }).join('');
    return '<div class="vd-setup">' +
      '<span class="eyebrow">Complete your setup</span>' +
      '<div class="vd-setup-row' + (picks.length === 1 ? ' is-one' : '') + '">' + cards + '</div>' +
    '</div>';
  }

  var shopToastTimer;
  function shopToast(msg) {
    var t = document.getElementById('VToast');
    if (!t) return;
    var label = t.querySelector('span:last-child');
    if (label) label.textContent = msg;
    t.classList.add('show');
    clearTimeout(shopToastTimer);
    shopToastTimer = setTimeout(function () { t.classList.remove('show'); }, 2200);
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-up-add]');
    if (!add || add.disabled) return;
    var vid = parseInt(add.getAttribute('data-up-add'), 10);
    if (!vid) return;
    add.disabled = true;
    add.classList.add('is-busy');
    enqueueCart(function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: vid, quantity: 1 })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return getCart(); })
        .then(function (cart) { return syncGifts(cart); })
        .then(function (res) {
          renderCart(res.cart);
          patchCartTable(res.cart);
          shopToast('Added to your cart');
        })
        .catch(function () {
          add.disabled = false;
          add.classList.remove('is-busy');
          shopToast('Couldn\u2019t add that. Please try again.');
        });
    });
  });

  function paintPageTotals(cart) {
    var el = document.querySelector('.cart-page [data-cart-totals]');
    if (!el) return;
    var html = totalsInner(cart);
    if (el.innerHTML !== html) el.innerHTML = html;
  }

  function discountBoxHtml(ctx) {
    return '<div class="vdisc" data-discount="' + ctx + '">' +
      '<button type="button" class="vdisc-toggle" data-discount-toggle aria-expanded="false">' +
        TAG_ICON.replace('class="vtot-ico" width="14" height="14"', 'width="15" height="15"') +
        '<span>Have a discount code?</span><span class="vdisc-plus" aria-hidden="true">+</span>' +
      '</button>' +
      '<div class="vdisc-form" data-discount-form hidden>' +
        '<input class="vdisc-input" type="text" data-discount-input placeholder="Discount code" aria-label="Discount code" autocomplete="off" autocapitalize="characters" autocorrect="off" spellcheck="false" enterkeyhint="go">' +
        '<button type="button" class="vdisc-apply" data-discount-apply>Apply</button>' +
      '</div>' +
      '<div class="vdisc-msg" data-discount-msg role="status" aria-live="polite"></div>' +
    '</div>';
  }

  function discBox(ctx) { return document.querySelector('[data-discount="' + ctx + '"]'); }

  function paintDisc(ctx) {
    var el = discBox(ctx);
    var st = DISC[ctx];
    if (!el || !st) return;
    var form = el.querySelector('[data-discount-form]');
    var toggle = el.querySelector('[data-discount-toggle]');
    var input = el.querySelector('[data-discount-input]');
    var msg = el.querySelector('[data-discount-msg]');
    if (form) form.hidden = !st.open;
    if (toggle) { toggle.hidden = st.open; toggle.setAttribute('aria-expanded', st.open ? 'true' : 'false'); }
    if (input && input.value !== st.value) input.value = st.value;
    if (msg) { msg.textContent = st.msg; msg.className = 'vdisc-msg' + (st.kind ? ' ' + st.kind : ''); }
  }

  /* Codes currently working on the cart */
  function activeCodes(cart) {
    if (!cart) return [];
    if (Array.isArray(cart.discount_codes)) {
      return cart.discount_codes
        .filter(function (c) { return c && c.code && c.applicable !== false; })
        .map(function (c) { return c.code; });
    }
    return discountLines(cart).filter(function (l) { return l.code; }).map(function (l) { return l.title; });
  }

  function codeWorks(cart, code) {
    var want = upper(code);
    if (Array.isArray(cart.discount_codes)) {
      return cart.discount_codes.some(function (c) { return c && upper(c.code) === want && c.applicable !== false; });
    }
    return discountLines(cart).some(function (l) { return l.code && upper(l.title) === want; });
  }

  function getCart() {
    return fetch((CFG.cartUrl || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .catch(function () { return lastCart; });
  }

  function setCodes(codes) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart update failed');
      return r.json();
    });
  }

  function refreshViews(cart) {
    renderCart(cart);
    patchCartTable(cart);
  }

  function setBusy(ctx, on) {
    var el = discBox(ctx);
    var btn = el && el.querySelector('[data-discount-apply]');
    if (btn) { btn.disabled = on; btn.textContent = on ? 'Applying…' : 'Apply'; }
  }

  function applyCode(ctx) {
    var st = DISC[ctx];
    var el = discBox(ctx);
    var input = el && el.querySelector('[data-discount-input]');
    st.value = (input ? input.value : st.value).trim();
    var code = upper(st.value); /* Shopify codes are case-insensitive; keep display consistent */
    if (!code) { st.msg = 'Enter a discount code.'; st.kind = 'err'; paintDisc(ctx); return; }
    if (activeCodes(lastCart).some(function (c) { return upper(c) === upper(code); })) {
      st.msg = upper(code) + ' is already applied.'; st.kind = 'ok'; paintDisc(ctx); return;
    }
    setBusy(ctx, true);
    enqueueCart(function () {
      var before;
      return getCart()
        .then(function (live) {
          before = activeCodes(live);
          return setCodes(before.concat(code));
        })
        .then(function (cart) {
          if (codeWorks(cart, code)) return { cart: cart, ok: true };
          /* Not valid for this cart: take it back off so it can't linger */
          return setCodes(before)
            .then(function (clean) { return { cart: clean, ok: false }; }, function () { return { cart: cart, ok: false }; });
        })
        .then(function (res) {
          if (res.ok) {
            st.open = false; st.value = '';
            st.msg = upper(code) + ' applied.'; st.kind = 'ok';
            var okMsg = st.msg; /* the code chip stays; the confirmation fades */
            setTimeout(function () { if (st.msg === okMsg) { st.msg = ''; st.kind = ''; paintDisc(ctx); } }, 4000);
          } else {
            st.msg = 'That code isn’t valid for this cart.'; st.kind = 'err';
          }
          refreshViews(res.cart);
          setBusy(ctx, false);
          paintDisc(ctx);
          if (!res.ok) {
            var again = discBox(ctx) && discBox(ctx).querySelector('[data-discount-input]');
            if (again) { again.focus(); again.select(); }
          }
        })
        .catch(function () {
          setBusy(ctx, false);
          st.msg = 'Couldn’t apply that code. Please try again.'; st.kind = 'err';
          paintDisc(ctx);
        });
    });
  }

  function removeCode(code) {
    document.querySelectorAll('[data-cart-totals]').forEach(function (el) { el.style.opacity = '.5'; });
    enqueueCart(function () {
      return getCart()
        .then(function (live) {
          return setCodes(activeCodes(live).filter(function (c) { return upper(c) !== upper(code); }));
        })
        .then(function (cart) {
          DISC.drawer.msg = DISC.page.msg = '';
          DISC.drawer.kind = DISC.page.kind = '';
          refreshViews(cart);
          paintDisc('page');
        })
        .catch(function () {})
        .then(function () {
          document.querySelectorAll('[data-cart-totals]').forEach(function (el) { el.style.opacity = ''; });
        });
    });
  }

  function discCtx(node) {
    var box = node.closest('[data-discount]');
    return box ? box.getAttribute('data-discount') : null;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var toggle = t.closest('[data-discount-toggle]');
    if (toggle) {
      var c1 = discCtx(toggle);
      if (!DISC[c1]) return;
      DISC[c1].open = true; DISC[c1].msg = ''; DISC[c1].kind = '';
      paintDisc(c1);
      var inp = discBox(c1).querySelector('[data-discount-input]');
      if (inp) inp.focus();
      return;
    }
    var apply = t.closest('[data-discount-apply]');
    if (apply) { var c2 = discCtx(apply); if (DISC[c2]) applyCode(c2); return; }
    var rm = t.closest('[data-discount-remove]');
    if (rm) { e.preventDefault(); removeCode(rm.getAttribute('data-discount-remove')); }
  });
  document.addEventListener('input', function (e) {
    var inp = e.target.closest && e.target.closest('[data-discount-input]');
    if (!inp) return;
    var c = discCtx(inp);
    if (DISC[c]) { DISC[c].value = inp.value; if (DISC[c].kind === 'err') { DISC[c].msg = ''; DISC[c].kind = ''; paintDisc(c); } }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var inp = e.target.closest && e.target.closest('[data-discount-input]');
    if (!inp) return;
    e.preventDefault(); /* never submit the cart form */
    var c = discCtx(inp);
    if (DISC[c]) applyCode(c);
  });

  function patchCartTable(cart) {
    lastCart = cart;
    paintPageTotals(cart);
    var table = document.querySelector('.cart-table');
    if (!table) return;
    var rows = '';
    cart.items.forEach(function (item, i) {
      var isFree = item.final_line_price === 0 && item.original_line_price > 0;
      var cut = !isFree && item.final_line_price < item.original_line_price;
      var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
      rows +=
        '<tr>' +
          '<td class="cart-img-cell"><a href="' + item.url + '">' +
            (img ? '<img class="cart-item-img" src="' + img + '" alt="" loading="lazy" width="74" height="74">' : '') +
          '</a></td>' +
          '<td>' +
            '<a class="cart-item-title" href="' + item.url + '">' + escapeHtml(item.product_title) + '</a> ' +
            (item.variant_title ? '<div class="cart-item-variant">' + escapeHtml(item.variant_title) + '</div>' : '') +
            (isFree ? '<div class="cart-free-tag"><svg class="gift-ico" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5C10 3 12 8 12 8s2-5 4.5-5a2.5 2.5 0 0 1 0 5"/></svg>Free gift</div>' : '') +
            '<a class="cart-remove" href="#" data-line="' + (i + 1) + '">Remove</a>' +
          '</td>' +
          '<td class="cart-qty-cell"><div class="cart-step">' +
            '<button type="button" data-cart-step="-1" aria-label="One less">\u2212</button>' +
            '<input class="cart-qty" type="number" name="updates[]" value="' + item.quantity + '" min="0" inputmode="numeric" data-line="' + (i + 1) + '" aria-label="Quantity for ' + escapeHtml(item.product_title) + '">' +
            '<button type="button" data-cart-step="1" aria-label="One more">+</button>' +
          '</div></td>' +
          '<td class="cart-price">' +
            (isFree
              ? '<span class="cart-was">' + formatMoney(item.original_line_price) + '</span><span class="cart-free-price">FREE</span>'
              : cut
                ? '<span class="cart-was">' + formatMoney(item.original_line_price) + '</span><span class="cart-now">' + formatMoney(item.final_line_price) + '</span>'
                : formatMoney(item.final_line_price)) +
          '</td>' +
        '</tr>';
    });
    table.innerHTML = rows;
  }

  if (CFG.isCartPage) {
    /* cart page steppers: change the number, then let the change handler below save it */
    document.addEventListener('click', function (e) {
      var step = e.target.closest('[data-cart-step]');
      if (!step) return;
      var input = step.parentElement.querySelector('.cart-qty');
      if (!input) return;
      var next = Math.max(0, Math.min(99, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-cart-step'), 10)));
      if (String(next) === input.value) return;
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    document.addEventListener('click', function (e) {
      var rm = e.target.closest('.cart-remove[data-line]');
      if (rm) {
        e.preventDefault();
        var rmLine = parseInt(rm.dataset.line, 10);
        enqueueCart(function () {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ line: rmLine, quantity: 0 })
          }).then(function (r) { return r.json(); })
            .then(function (cart) { return syncGifts(cart); })
            .then(function (result) { patchCartTable(result.cart); paintCount(result.cart.item_count); })
            .catch(function () {});
        });
      }
    });
    document.addEventListener('change', function (e) {
      var qty = e.target.closest('.cart-qty[data-line]');
      if (qty) {
        var qtyLine = parseInt(qty.dataset.line, 10);
        var qtyValue = parseInt(qty.value, 10) || 0;
        enqueueCart(function () {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ line: qtyLine, quantity: qtyValue })
          }).then(function (r) { return r.json(); })
            .then(function (cart) { return syncGifts(cart); })
            .then(function (result) { patchCartTable(result.cart); paintCount(result.cart.item_count); })
            .catch(function () {});
        });
      }
    });
  }

  function fetchCart(open) {
    return enqueueCart(function () {
      return fetch((CFG.cartUrl || '/cart') + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { return syncGifts(cart); })
        .then(function (result) {
          renderCart(result.cart);
          if (open) openCart();
          if (result.changed && CFG.isCartPage) { patchCartTable(result.cart); } else { paintPageTotals(result.cart); }
          return result.cart;
        })
        .catch(function () {});
    });
  }

  function changeLine(line, qty) {
    DISC.drawer.msg = ''; DISC.drawer.kind = '';
    var row = dBody && dBody.querySelector('.vd-item[data-line="' + line + '"]');
    if (row) row.classList.add('is-busy');
    return enqueueCart(function () {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      })
        .then(function (r) { if (!r.ok) throw new Error('change failed'); return r.json(); })
        .then(function (cart) { return syncGifts(cart); })
        .then(function (result) {
          renderCart(result.cart);
          patchCartTable(result.cart);
        })
        .catch(function () {
          /* put the real numbers back if the change didn't go through */
          lastSig = '';
          return getCart().then(function (c) { if (c) renderCart(c); });
        });
    });
  }

  /* +/- feel instant: the number updates on tap, and quick taps are
     bundled into one update ~0.3s after the last tap. */
  var stepTimers = {}, stepPending = {};
  function stepTap(stepBtn) {
    var row = stepBtn.closest('.vd-item');
    var countEl = row && row.querySelector('.vd-step span');
    if (!row || !countEl) return;
    var line = parseInt(row.dataset.line, 10);
    var next = Math.max(0, (parseInt(countEl.textContent, 10) || 0) + parseInt(stepBtn.dataset.step, 10));
    countEl.textContent = next;
    stepPending[line] = next;
    row.classList.toggle('is-removing', next === 0);
    clearTimeout(stepTimers[line]);
    stepTimers[line] = setTimeout(function () {
      delete stepTimers[line];
      delete stepPending[line];
      changeLine(line, next);
    }, 320);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('.vd-close') || e.target.classList.contains('vd-veil')) { closeCart(); return; }
    if (e.target.closest('#VDCheckout')) { window.location.href = '/checkout'; return; }

    var step = e.target.closest('[data-step]');
    if (step) { stepTap(step); return; }

    var opener = e.target.closest('[data-open-cart]');
    if (opener && drawer) {
      e.preventDefault();
      /* already have the cart: slide open right away, refresh quietly behind it */
      if (lastCart) { openCart(); fetchCart(false); } else { fetchCart(true); }
    }
  });

  /* Expose for viora-extras.js add-to-cart hook */
  window.VioraCart = { open: function () { fetchCart(true); }, refresh: fetchCart };

  /* ---------------- predictive search ---------------- */
  var sPanel = document.getElementById('SearchPanel');
  var sInput = document.getElementById('SearchInput');
  var sResults = document.getElementById('SearchResults');
  var sTimer, sLastFocus;

  function openSearch() {
    if (body.classList.contains('search-open')) return;
    sLastFocus = document.activeElement;
    body.classList.remove('menu-open');
    body.classList.add('search-open');
    lockScroll();
    setTimeout(function () { if (sInput) sInput.focus(); }, 260);
  }
  function closeSearch() {
    if (!body.classList.contains('search-open')) return;
    body.classList.remove('search-open');
    unlockScroll();
    if (sLastFocus && sLastFocus.focus) sLastFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-search]')) { e.preventDefault(); openSearch(); return; }
    if (e.target.closest('.vs-close') || e.target.classList.contains('vs-veil')) closeSearch();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (body.classList.contains('search-open')) closeSearch();
    else if (body.classList.contains('cart-open')) closeCart();
    else if (body.classList.contains('menu-open')) body.classList.remove('menu-open');
  });

  if (sInput) {
    sInput.addEventListener('input', function () {
      clearTimeout(sTimer);
      var q = sInput.value.trim();
      if (q.length < 2) { if (sResults) sResults.innerHTML = ''; return; }
      sTimer = setTimeout(function () { suggest(q); }, 220);
    });
    sInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && sInput.value.trim()) {
        window.location.href = '/search?q=' + encodeURIComponent(sInput.value.trim());
      }
    });
  }

  function suggestPrice(p) {
    if (p == null) return '';
    if (typeof p === 'number') return formatMoney(p);
    var str = String(p);
    if (/[^\d.,\s]/.test(str)) return str;          // already formatted with a symbol
    var num = parseFloat(str.replace(/,/g, ''));
    if (isNaN(num)) return '';
    return formatMoney(str.indexOf('.') > -1 ? Math.round(num * 100) : num);
  }

  function suggest(q) {
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!sResults) return;
        var items = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (!items.length) {
          sResults.innerHTML = '<div class="vs-empty">No matches for “' + escapeHtml(q) + '”. Try “sleeves”, “one touch”, or a player or set name.</div>';
          return;
        }
        sResults.innerHTML = items.map(function (p) {
          var img = p.image || (p.featured_image && p.featured_image.url) || '';
          var zero = parseFloat(String(p.price == null ? '' : p.price).replace(/[^\d.]/g, '')) === 0;
          return '<a class="vs-item" href="' + p.url + '">' +
            (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<span class="vs-thumb"></span>') +
            '<div class="vs-txt"><b>' + escapeHtml(p.title) + '</b><span>' + (zero ? 'Coming soon' : suggestPrice(p.price)) + '</span></div></a>';
        }).join('');
      })
      .catch(function () {
        if (sResults) sResults.innerHTML = '<div class="vs-empty">Search is unavailable right now. Press Enter to search the full store.</div>';
      });
  }

  /* ---------------- product: mobile swipe gallery dots ---------------- */
  var swipe = document.querySelector('.pd-swipe');
  var dots = document.querySelector('.pd-dots');
  if (swipe && dots) {
    swipe.addEventListener('scroll', function () {
      var i = Math.round(swipe.scrollLeft / swipe.clientWidth);
      dots.querySelectorAll('i').forEach(function (d, n) { d.classList.toggle('on', n === i); });
    }, { passive: true });
  }

  /* ---------------- keep mobile tab bar out of the buy bar's way ---------------- */
  var mbar = document.getElementById('MobileBuy');
  if (mbar && 'MutationObserver' in window) {
    new MutationObserver(function () {
      body.classList.toggle('buybar-on', mbar.classList.contains('on'));
    }).observe(mbar, { attributes: true, attributeFilter: ['class'] });
  }

  /* ---------------- initial paint ---------------- */
  if (drawer || GIFT_RULES.length) fetchCart(false);
})();
